/**
 * Checks the height of the form in the hero top row and applies a min-height to the second row to make sure the footer doesn't overlap the form.
 */
export const heroTopRowHeight = () => {
  const heroTopRow = document.querySelector('.alz-hero-top-row') as HTMLElement | null;
  if (!heroTopRow) return;

  const heroTopRowPhotoColumn = heroTopRow.querySelector(
    '.en__component--column:first-child',
  ) as HTMLElement;
  const heroTopRowFormColumn = heroTopRow.querySelector(
    '.en__component--column:last-child',
  ) as HTMLElement;
  const main = document.querySelector('main') as HTMLElement;

  const updateMinHeight = () => {
    const MAIN_SPACING_ABOVE = 38;
    const formHeight = Math.round(heroTopRowFormColumn.getBoundingClientRect().height);
    const photoHeight = Math.round(heroTopRowPhotoColumn.getBoundingClientRect().height);
    const overlap = photoHeight / 2 + formHeight + MAIN_SPACING_ABOVE; // form top is 1/2 way from top of photo

    main.style.minHeight = isDesktopView() && overlap > 0 ? `${overlap}px` : '';
  };

  const observer = new ResizeObserver(updateMinHeight);
  observer.observe(heroTopRowFormColumn);
};

const isDesktopView = () => window.innerWidth >= 1024;
